export const ADD_PHYSICAL_INVENTORY = "ADD_PHYSICAL_INVENTORY";
export const ADD_PHYSICAL_INVENTORY_SUCCESS = "ADD_PHYSICAL_INVENTORY_SUCCESS";
export const ADD_PHYSICAL_INVENTORY_MANUAL_RX = "ADD_PHYSICAL_INVENTORY_MANUAL_RX";
export const ADD_PHYSICAL_INVENTORY_MANUAL_RX_SUCCESS = "ADD_PHYSICAL_INVENTORY_MANUAL_RX_SUCCESS";
export const ADD_PHYSICAL_INVENTORY_MANUAL_RX_WITHOUT_LOT_NO = "ADD_PHYSICAL_INVENTORY_MANUAL_RX_WITHOUT_LOT_NO";
export const ADD_PHYSICAL_INVENTORY_MANUAL_RX_WITHOUT_LOT_NO_SUCCESS = "ADD_PHYSICAL_INVENTORY_MANUAL_RX_WITHOUT_LOT_NO_SUCCESS";
export const ADD_PHYSICAL_INVENTORY_OTC = 'ADD_PHYSICAL_INVENTORY_OTC'
export const ADD_PHYSICAL_INVENTORY_OTC_SUCCESS = 'ADD_PHYSICAL_INVENTORY_OTC_SUCCESS'
export const ADD_PHYSICAL_INVENTORY_RX = 'ADD_PHYSICAL_INVENTORY_RX'
export const ADD_PHYSICAL_INVENTORY_RX_SUCCESS = 'ADD_PHYSICAL_INVENTORY_RX_SUCCESS'
export const ADD_OTC_PRODUCT = "ADD_OTC_PRODUCT";
export const ADD_OTC_PRODUCT_SUCCESS = "ADD_OTC_PRODUCT_SUCCESS";
export const ADD_RX_PRODUCT = "ADD_RX_PRODUCT";
export const ADD_RX_PRODUCT_SUCCESS = "ADD_RX_PRODUCT_SUCCESS";
export const ADD_OTC_MANUAL_PRODUCT = "ADD_OTC_MANUAL_PRODUCT";
export const ADD_OTC_MANUAL_PRODUCT_SUCCESS = "ADD_OTC_MANUAL_PRODUCT_SUCCESS";
export const ADD_PHYSICAL_INVENTORY_OTC_RX_WITHOUT_LOT_NO = 'ADD_PHYSICAL_INVENTORY_OTC_RX_WITHOUT_LOT_NO'
export const ADD_PHYSICAL_INVENTORY_OTC_RX_WITHOUT_LOT_NO_SUCCESS = 'ADD_PHYSICAL_INVENTORY_OTC_RX_WITHOUT_LOT_NO_SUCCESS'

export const ADD_NEW_PHYSICAL_INVENTORY = "ADD_NEW_PHYSICAL_INVENTORY";
export const ADD_NEW_PHYSICAL_INVENTORY_SUCCESS = "ADD_NEW_PHYSICAL_INVENTORY_SUCCESS";
export const EDIT_PHYSICAL_INVENTORY = "EDIT_PHYSICAL_INVENTORY";
export const EDIT_PHYSICAL_INVENTORY_SUCCESS = "EDIT_PHYSICAL_INVENTORY_SUCCESS";
export const DELETE_PHYSICAL_INVENTORY = "DELETE_PHYSICAL_INVENTORY";
export const DELETE_PHYSICAL_INVENTORY_SUCCESS = "DELETE_PHYSICAL_INVENTORY_SUCCESS";